import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-52af3abd"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bg" }
const _hoisted_2 = { class: "bar" }
const _hoisted_3 = {
  key: 0,
  class: "day-box ws_ml25"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "天", -1))
const _hoisted_5 = { class: "ws_drawer_footer" }

import { ref, watch, computed } from 'vue'
import { isEmpty } from 'lodash'
import {
  queryLocusAoiAll,
  alarmStrategyUpdate,
  alarmStrategyAdd,
  alarmStrategyDetail,
} from '@/api'
import {
  CODE_ENUM,
  ALARM_LEVEL_TYPE,
  WARNING_TYPE_ENUM,
  EVENT_ALARM_TYPE,
} from '@/common'
import { ElMessage, genFileId } from 'element-plus'
import i18n from '@/i18n'


export default /*#__PURE__*/_defineComponent({
  __name: 'form-drawer-4',
  props: ['visible', 'data'],
  emits: ['update:visible', 'on-success'],
  setup(__props, { emit: $emit }) {

const props = __props;

const t = i18n.global.t




// 等级告警
const levelOps = [
  {
    label: t('W_TACTICS.main'),
    value: ALARM_LEVEL_TYPE.ALARM_MAIN,
  },
  {
    label: t('W_TACTICS.minor'),
    value: ALARM_LEVEL_TYPE.ALARM_MINOR,
  },
  {
    label: t('W_TACTICS.urgency'),
    value: ALARM_LEVEL_TYPE.ALARM_URGENCY,
  },
  {
    label: t('W_TACTICS.warn'),
    value: ALARM_LEVEL_TYPE.ALARM_WARN,
  },
  // {
  //   label: t('W_TACTICS.clean'),
  //   value: ALARM_LEVEL_TYPE.ALARM_CLEAN,
  // },
]

// 事件下啦选项
const eventTypeOps = [
  {
    label: '监测到野生动物',
    value: EVENT_ALARM_TYPE.EVENT_ANIMAL,
  },
  {
    label: '监测到火警',
    value: EVENT_ALARM_TYPE.EVENT_FIRE,
  },
  {
    label: '离线告警',
    value: EVENT_ALARM_TYPE.EVENT_OFFLINE,
  },
  {
    label: '星历未更新',
    value: EVENT_ALARM_TYPE.EVENT_UNUPDATE,
  },
]

const formRef = ref()

const form: any = ref({
  name: '',
  alarmLevelCode: undefined,
  eventTypeCode: '',
  conditionDuring: undefined,
  conditionDuringUnitCode: 'DAY',
})

const rules: any = {
  name: [{ required: true, message: '请输入' }],
  alarmLevelCode: [{ required: true, message: '请选择' }],
  eventTypeCode: [{ required: true, message: '请选择' }],
  conditionDuring: [{ required: true, message: '请输入' }],
}

watch(
  () => props.visible,
  () => {
    if (props.visible) {
      queryDetial()
    }
  },
  {
    deep: true,
  }
)

const queryDetial = async () => {
  if (!props.data.id) {
    return
  }
  const res: any = await alarmStrategyDetail({
    alarmStrategyId: props.data?.id,
  })
  if (res?.code === CODE_ENUM.SUCCESS) {
    const mo = res?.data || {}
    const { eventTypeCode, name, alarmLevelCode, conditionDuring } = mo
    form.value = {
      eventTypeCode,
      name,
      alarmLevelCode,
      conditionDuring: conditionDuring ? Number(conditionDuring) : undefined,
      conditionDuringUnitCode: 'DAY',
    }
  }
}

const submit = () => {
  formRef.value.validate((valid: boolean) => {
    if (valid) {
      handleAPI()
    }
  })
}

const loading = ref(false)
const handleAPI = async () => {
  loading.value = true
  const {
    conditionDuring,
    name,
    alarmLevelCode,
    eventTypeCode,
    conditionDuringUnitCode,
  } = form.value
  const fn = props.data.id ? alarmStrategyUpdate : alarmStrategyAdd
  const res: any = await fn({
    conditionDuring,
    name,
    alarmLevelCode,
    eventTypeCode,
    conditionDuringUnitCode,
    triggerId: props.data?.id,
    triggerTypeCode: WARNING_TYPE_ENUM.EVENT,
  }).finally(() => {
    loading.value = false
  })
  if (res.code === CODE_ENUM.SUCCESS) {
    ElMessage.success(res?.msg)
    $emit('on-success')
    handleClose()
  }
}

const handleClose = () => {
  $emit('update:visible', false)
  formRef.value?.resetFields?.()
}

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_drawer = _resolveComponent("el-drawer")!

  return (_openBlock(), _createBlock(_component_el_drawer, {
    "model-value": props.visible,
    "destroy-on-close": "",
    title: props.data.id ? '编辑告警策略' : '新建告警策略',
    size: "780px",
    "before-close": handleClose,
    "label-position": "left"
  }, {
    footer: _withCtx(() => [
      _createElementVNode("span", _hoisted_5, [
        _createVNode(_component_el_button, {
          onClick: submit,
          loading: loading.value,
          type: "primary"
        }, {
          default: _withCtx(() => [
            _createTextVNode(" 确定 ")
          ]),
          _: 1
        }, 8, ["loading"]),
        _createVNode(_component_el_button, {
          onClick: handleClose,
          plain: ""
        }, {
          default: _withCtx(() => [
            _createTextVNode("取消")
          ]),
          _: 1
        })
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_form, {
        ref_key: "formRef",
        ref: formRef,
        model: form.value,
        rules: rules,
        class: "form ws_common_form",
        "label-width": 100
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, {
            label: _ctx.$t('W_TACTICS.labelNameForm'),
            prop: "name"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: form.value.name,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.name) = $event)),
                modelModifiers: { trim: true },
                maxlength: "50",
                placeholder: _ctx.$t('W_TACTICS.labelNamePla'),
                style: {"width":"355px"}
              }, null, 8, ["modelValue", "placeholder"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_el_form_item, {
                label: "",
                "label-width": 15,
                prop: "eventTypeCode"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: form.value.eventTypeCode,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.eventTypeCode) = $event)),
                    class: "ws_select",
                    clearable: "",
                    style: {"width":"160px"},
                    placeholder: "请选择事件"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(eventTypeOps, (item) => {
                        return _createVNode(_component_el_option, {
                          key: item.value,
                          label: item.label,
                          value: item.value
                        }, null, 8, ["label", "value"])
                      }), 64))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              (
              [
                _unref(EVENT_ALARM_TYPE).EVENT_OFFLINE,
                _unref(EVENT_ALARM_TYPE).EVENT_UNUPDATE,
              ].includes(form.value.eventTypeCode)
            )
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createVNode(_component_el_form_item, {
                      "label-width": "5",
                      prop: "conditionDuring",
                      class: "operation-form"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input_number, {
                          style: {"width":"155px"},
                          class: "select_value input-number",
                          modelValue: form.value.conditionDuring,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.value.conditionDuring) = $event)),
                          precision: 0,
                          controls: true,
                          "controls-position": "right",
                          min: 1,
                          max: 100
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _hoisted_4
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createVNode(_component_el_form_item, {
            label: _ctx.$t('W_TACTICS.alarmLevel'),
            prop: "alarmLevelCode"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: form.value.alarmLevelCode,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.value.alarmLevelCode) = $event)),
                class: "ws_select",
                clearable: "",
                style: {"width":"355px"}
              }, {
                default: _withCtx(() => [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(levelOps, (item) => {
                    return _createVNode(_component_el_option, {
                      key: item.value,
                      label: item.label,
                      value: item.value
                    }, null, 8, ["label", "value"])
                  }), 64))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _: 1
      }, 8, ["model"])
    ]),
    _: 1
  }, 8, ["model-value", "title"]))
}
}

})